"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useJourneyListContext_1 = require("../context/journeys/useJourneyListContext");
var useHasJourney = function () {
    var journeyList = useJourneyListContext_1.default().journeyList;
    var hasJourney = react_1.useCallback(function (journeyType) {
        return journeyList.some(function (journey) { return journey.journeyType === journeyType; });
    }, [journeyList]);
    return { hasJourney: hasJourney };
};
exports.default = useHasJourney;
